import React from "react";
import { Modal } from "react-bootstrap";
import "./Account_Created_Modal.css";
import { Account_Created_Successfully } from "../../../lottie/account-created-lottie/Account_Created_Lottie";

const Account_Created_Modal = ({
  showAccountModal,
  handleAccountModalClose,
  text,txt
}) => {
  return (
    <div className="Modal-wrapper">
      <Modal
        show={showAccountModal}
        onHide={handleAccountModalClose}
        centered
        className="account-created-modal"
      >
        <Modal.Body className="modal-body text-center p-0">
          <div>
            <div className="lottie-container">
              <Account_Created_Successfully />
            </div>
            <div className="account-text">
              <h3>{text || "Account Created Successfully!"}</h3>
              <p>{" " || "Let's Begin Your Journey With Oll Type Services"} </p>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default Account_Created_Modal;
